import React, { useContext } from 'react';
import ThemeContext from '../contexts/ThemeContext';
import './ThemeSwitcher.scss';

const ThemeSwitcher = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  const themes = [
    { id: 'default', name: 'Default' },
    { id: 'newyear', name: 'New Year' },
    { id: 'cny', name: 'Chinese New Year' },
    { id: 'thaipusam', name: 'Thaipusam' },
    { id: 'hariRayaAidilfitri', name: 'Hari Raya Aidilfitri' },
    { id: 'labour', name: 'Labour Day' },
    { id: 'wesak', name: 'Wesak Day' },
    { id: 'hariRayaHaji', name: 'Hari Raya Haji' },
    { id: 'merdeka', name: 'Merdeka Day' },
    { id: 'malaysia', name: 'Malaysia Day' },
    { id: 'deepavali', name: 'Deepavali' },
    { id: 'christmas', name: 'Christmas' }
  ];

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('manualTheme', newTheme);
  };

  return (
    <div className="theme-switcher">
      <label htmlFor="theme-select">Theme:</label>
      <select 
        id="theme-select"
        value={theme}
        onChange={(e) => handleThemeChange(e.target.value)}
      >
        {themes.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ThemeSwitcher;
